import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { cleanRut, validateRut, formatRut } from 'rutlib/lib';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { EntregaEquipoLinkService } from 'src/app/pages/services/entrega-equipo-link.service';
import { EquipoTecnologicoService } from 'src/app/pages/services/equipo-tecnologico.service';
import { TipoMovimientoEntregaEquipo } from 'src/app/shared/models/entrega-equipo-link.interface';

@Component({
  selector: 'app-editar-link-dialog',
  templateUrl: './editar-link-dialog.component.html',
})
export class EditarLinkDialogComponent {

  tiposMovimiento: TipoMovimientoEntregaEquipo[] = ['ENTREGA', 'DEVOLUCION', 'REEMPLAZO'];

  form: {
    rut: string;
    esExtranjero: boolean;
    tipoMovimiento: TipoMovimientoEntregaEquipo;
    observacion: string;
  };

  equipoActual: any;
  textoBusquedaEquipo: string = '';
  equiposEncontrados: any[] = [];
  guardando: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditarLinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private alert: AlertHelper,
    private entregaEquipoLinkService: EntregaEquipoLinkService,
    private equipoTecnologicoService: EquipoTecnologicoService
  ) {
    const link = data.link;
    this.form = {
      rut: link.rut ? formatRut(link.rut) : '',
      esExtranjero: !!link.esExtranjero,
      tipoMovimiento: link.tipoMovimiento,
      observacion: link.observacion || ''
    };
    this.equipoActual = link.fk_equipoTecnologico ? { id: link.fk_equipoTecnologico } : null;
  }

  onBuscarEquipo(event: Event) {
    const texto = (event.target as HTMLInputElement).value;
    if (!texto || texto.trim().length === 0) {
      this.equiposEncontrados = [];
      return;
    }
    this.equipoTecnologicoService.buscarEquipos(texto.trim()).subscribe(res => {
      this.equiposEncontrados = res.data || [];
    });
  }

  seleccionarEquipo(equipo: any) {
    this.equipoActual = equipo;
    this.equiposEncontrados = [];
    this.textoBusquedaEquipo = '';
  }

  guardar() {
    if (!this.form.esExtranjero) {
      const rutLimpio = cleanRut(this.form.rut);
      if (!validateRut(rutLimpio)) {
        this.alert.error_small('El rut ingresado no es válido, revise el formato o marque "Es extranjero"');
        return;
      }
    }
    this.guardando = true;
    const cambios: any = {
      rut: this.form.rut.trim(),
      esExtranjero: this.form.esExtranjero,
      tipoMovimiento: this.form.tipoMovimiento,
      observacion: this.form.observacion,
      fk_equipoTecnologico: this.equipoActual ? this.equipoActual.id : null
    };
    this.entregaEquipoLinkService.anular(this.data.link.id, cambios).subscribe({
      next: (res) => {
        this.guardando = false;
        if (res.success) {
          this.alert.success_small(res.msg || 'Link actualizado');
          this.dialogRef.close(cambios);
        } else {
          this.alert.error_small(res.msg || 'No se pudo actualizar');
        }
      },
      error: () => { this.guardando = false; }
    });
  }

  cancelar() {
    this.dialogRef.close(false);
  }

}
